import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ppa-carrossel',
  templateUrl: './carrossel.component.html',
  styleUrls: ['./carrossel.component.css']
})
export class CarrosselComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
